var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticClass:"text-center"},[_c('Loading')],1):_c('iframe',{attrs:{"width":"100%","height":"1200px","src":_vm.src}})])}
var staticRenderFns = []

export { render, staticRenderFns }